var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceRightGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.53262H4.77778C4.30628 5.53262 3.8541 5.71992 3.5207 6.05332C3.1873 6.38672 3 6.83891 3 7.3104V19.7548C3 20.2263 3.1873 20.6785 3.5207 21.0119C3.8541 21.3453 4.30628 21.5326 4.77778 21.5326H17.2222C17.6937 21.5326 18.1459 21.3453 18.4793 21.0119C18.8127 20.6785 19 20.2263 19 19.7548V13.5326",
    stroke: "url(#paint0_linear_10229_1115)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6662 4.10461C18.0325 3.73837 18.5292 3.53262 19.0471 3.53262C19.5651 3.53262 20.0618 3.73837 20.428 4.10461C20.7943 4.47084 21 4.96756 21 5.4855C21 6.00343 20.7943 6.50015 20.428 6.86639L11.6824 15.612L8 16.5326L8.92059 12.8502L17.6662 4.10461Z",
    stroke: "url(#paint1_linear_10229_1115)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10229_1115",
    x1: 1.96,
    y1: 13.5326,
    x2: 17.9945,
    y2: 21.9081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10229_1115",
    x1: 7.155,
    y1: 10.0326,
    x2: 20.183,
    y2: 16.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceRightGradient);
export default __webpack_public_path__ + "static/media/place-right-gradient.dfc5f6d36ff918b8d8142436229ff79e.svg";
export { ForwardRef as ReactComponent };